<template>
  <el-row>
    <el-col class="classify">
      <div
        v-for="item in bookTypeList"
        :key="item.id"
        class="classify-item"
        :class="{ 'classify-item-active': item.id === activeIcon }"
        @click="changeCategory(item.id)"
      >
        <i v-html="item.cover"></i>
        <span>{{ item.name }}</span>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { category } from '@/api/index'
export default {
  name: 'classification',
  components: {},
  props: [],
  data() {
    return {
      bookTypeList: [],
      activeIcon: -1,
    }
  },
  watch: {},
  computed: {},
  created() {
    if (this.$route.query.category || this.$route.query.category === 0)
      this.activeIcon = parseFloat(this.$route.query.category)
    this.getCategory()
  },
  mounted() {},
  methods: {
    getCategory() {
      category().then((res) => {
        let bookTypeList = [
          {
            cover: '<i class="icon i-subj-all"></i>',
            id: -1,
            name: '全部',
            order: 0,
          },
          {
            cover: '<i class="icon i-subj-new"></i>',
            id: 0,
            name: '新的',
            order: 0,
          },
        ]
        const { data } = res
        data.forEach((v) => {
          if (v.name !== '新的' && v.name !== '全部') bookTypeList.push(v)
        })
        this.bookTypeList = bookTypeList
      })
    },
    changeCategory(id) {
      this.activeIcon = id
      this.$emit('upData', id)
    },
  },
}
</script>

<style lang="scss" scoped>
.classify {
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  border-radius: 5px;
  padding: 5px;
  .classify-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #6d7382;
    padding: 20px 0;
    margin: 0 5px;
    width: 100%;
    cursor: pointer;
    i {
      font-size: xx-large;
      margin-bottom: 10px;
    }
  }
  .classify-item:hover,
  .classify-item-active,
  .classify-item:focus {
    background: #f2f5f9;
    box-shadow: inset 0 2px 2px rgb(69 87 113 / 20%);
    border-radius: 3px;
    i {
      color: #0a90cc;
    }
  }
}

@media (max-width: 800px) {
  .classify {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    .classify-item {
      width: 33.333%;
      margin: 0;
    }
  }
}
</style>